/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const CHECK_CIRCLE_PATH =
  'M9.81338 5.86004L6.95338 8.72671L5.85338 7.62671C5.79361 7.55692 5.72007 7.50024 5.63736 7.46022C5.55465 7.42021 5.46456 7.39772 5.37275 7.39418C5.28093 7.39063 5.18938 7.4061 5.10383 7.43962C5.01828 7.47313 4.94058 7.52397 4.87561 7.58894C4.81064 7.65391 4.7598 7.73161 4.72629 7.81716C4.69277 7.90271 4.6773 7.99426 4.68084 8.08608C4.68439 8.17789 4.70688 8.26798 4.74689 8.35069C4.78691 8.4334 4.84359 8.50694 4.91338 8.56671L6.48004 10.14C6.54234 10.2018 6.61621 10.2507 6.69744 10.2839C6.77866 10.3171 6.86564 10.3339 6.95338 10.3334C7.12827 10.3326 7.29587 10.2632 7.42004 10.14L10.7534 6.80671C10.8159 6.74473 10.8655 6.671 10.8993 6.58976C10.9332 6.50852 10.9506 6.42138 10.9506 6.33337C10.9506 6.24537 10.9332 6.15823 10.8993 6.07699C10.8655 5.99575 10.8159 5.92202 10.7534 5.86004C10.6285 5.73587 10.4595 5.66618 10.2834 5.66618C10.1073 5.66618 9.93829 5.73587 9.81338 5.86004ZM8.00004 1.33337C6.6815 1.33337 5.39257 1.72437 4.29624 2.45691C3.19991 3.18945 2.34543 4.23064 1.84085 5.44882C1.33626 6.66699 1.20424 8.00744 1.46148 9.30064C1.71871 10.5938 2.35365 11.7817 3.286 12.7141C4.21835 13.6464 5.40624 14.2814 6.69944 14.5386C7.99265 14.7958 9.33309 14.6638 10.5513 14.1592C11.7694 13.6547 12.8106 12.8002 13.5432 11.7038C14.2757 10.6075 14.6667 9.31858 14.6667 8.00004C14.6667 7.12456 14.4943 6.25765 14.1592 5.44882C13.8242 4.63998 13.3331 3.90505 12.7141 3.286C12.095 2.66694 11.3601 2.17588 10.5513 1.84084C9.74243 1.50581 8.87552 1.33337 8.00004 1.33337ZM8.00004 13.3334C6.94521 13.3334 5.91406 13.0206 5.037 12.4345C4.15994 11.8485 3.47635 11.0156 3.07269 10.041C2.66902 9.06648 2.5634 7.99412 2.76919 6.95956C2.97498 5.92499 3.48293 4.97468 4.22881 4.2288C4.97469 3.48292 5.925 2.97497 6.95956 2.76919C7.99413 2.5634 9.06648 2.66902 10.041 3.07268C11.0156 3.47635 11.8485 4.15994 12.4345 5.037C13.0206 5.91406 13.3334 6.94521 13.3334 8.00004C13.3334 9.41453 12.7715 10.7711 11.7713 11.7713C10.7711 12.7715 9.41453 13.3334 8.00004 13.3334Z';

const CHECK_CIRCLE_FILLED_PATH =
  'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L7 8.58579L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L11.7071 6.70711Z';

const BUBBLE_CHECK_PATH_BUBBLE =
  'M18.383 5.4896C20.1132 2.22541 23.5451 0 27.5 0C31.4549 0 34.8868 2.22541 36.617 5.48959C40.1486 4.40492 44.1489 5.258 46.9454 8.05456C49.742 10.8511 50.5951 14.8514 49.5104 18.383C52.7746 20.1132 55 23.5451 55 27.5C55 31.4549 52.7746 34.8868 49.5104 36.617C50.5951 40.1486 49.742 44.1489 46.9454 46.9454C44.1489 49.742 40.1486 50.5951 36.617 49.5104C34.8868 52.7746 31.4549 55 27.5 55C23.5451 55 20.1132 52.7746 18.383 49.5104C14.8514 50.5951 10.8511 49.742 8.05455 46.9454C5.25802 44.1489 4.40495 40.1486 5.4896 36.617C2.22541 34.8868 0 31.4549 0 27.5C0 23.5451 2.22541 20.1132 5.48959 18.383C4.40492 14.8514 5.25801 10.8511 8.05456 8.05456C10.8511 5.25801 14.8514 4.40493 18.383 5.4896ZM40.5968 20.5991C40.7982 20.8005 40.7982 21.1269 40.5968 21.3283L24.3112 37.6138C24.1099 37.8152 23.7834 37.8152 23.582 37.6138L14.5885 28.6203C14.3872 28.419 14.3872 28.0925 14.5885 27.8911L17.5053 24.9743C17.7067 24.7729 18.0332 24.7729 18.2345 24.9743L23.582 30.3218C23.7834 30.5232 24.1099 30.5232 24.3112 30.3218L36.9508 17.6823C37.1521 17.4809 37.4786 17.4809 37.68 17.6823L40.5968 20.5991Z';

const BUBBLE_CHECK_PATH_CHECK =
  'M40.5968 21.3283C40.7982 21.1269 40.7982 20.8005 40.5968 20.5991L37.68 17.6823C37.4786 17.4809 37.1521 17.4809 36.9508 17.6823L24.3112 30.3218C24.1099 30.5232 23.7834 30.5232 23.582 30.3218L18.2345 24.9743C18.0332 24.7729 17.7067 24.7729 17.5053 24.9743L14.5885 27.8911C14.3872 28.0925 14.3872 28.419 14.5885 28.6203L23.582 37.6138C23.7834 37.8152 24.1099 37.8152 24.3112 37.6138L40.5968 21.3283Z';

/** Default fill — DS semantic success token. */
export const CHECK_CIRCLE_FILLED_ICON_DEFAULT_FILL = 'var(--ds-color-success, var(--pal-green-700, #0FC64C))';
export const BUBBLE_CHECK_ICON_DEFAULT_FILL = CHECK_CIRCLE_FILLED_ICON_DEFAULT_FILL;

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Outline check-in-circle (16×16). Color via `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const CheckCircleIcon = ({
  size = 20,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={CHECK_CIRCLE_PATH} fill="currentColor" />
  </svg>
);

CheckCircleIcon.propTypes = iconPropTypes;

/**
 * Filled check-in-circle (16×16). Defaults to DS success token.
 * Pass `fill="currentColor"` to inherit from CSS `color`.
 */
const CheckCircleFilledIcon = ({
  size = 20,
  fill = CHECK_CIRCLE_FILLED_ICON_DEFAULT_FILL,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d={CHECK_CIRCLE_FILLED_PATH} fill={fill} />
  </svg>
);

CheckCircleFilledIcon.propTypes = {
  ...iconPropTypes,
  fill: PropTypes.string,
};

/**
 * Large bubble + check (55×55 asset). Used in modal success states.
 * Defaults to DS success token for bubble; white checkmark.
 */
const BubbleCheckIcon = ({
  size = 55,
  fill = BUBBLE_CHECK_ICON_DEFAULT_FILL,
  checkFill = 'var(--ds-color-white, #ffffff)',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d={BUBBLE_CHECK_PATH_BUBBLE} fill={fill} />
    <path d={BUBBLE_CHECK_PATH_CHECK} fill={checkFill} />
  </svg>
);

BubbleCheckIcon.propTypes = {
  ...iconPropTypes,
  fill: PropTypes.string,
  checkFill: PropTypes.string,
};

export { CheckCircleIcon, CheckCircleFilledIcon, BubbleCheckIcon };
export default CheckCircleIcon;
